import { container } from '../common/container';
import { RemoteWidgetHandlerClassSymbol } from '../common/symbols';
import { RemoteWidgetHandler } from './remote-widget-handler';
container.set(RemoteWidgetHandlerClassSymbol, RemoteWidgetHandler);
export * from '../types';
export * from '../components';
export * from '../common/remote-handler-factory';
export { RemoteWidgetHandler };
export { applyWidgetMarkup, applyWidgetHtml } from '../utils';
